import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import ProductVariantColorSelect from '../../components/product-variant-color-select';
import FloatingMessage from '../../components/floating-message';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
$(() => {
    RevealWhenVisible.init();
    ProductVariantColorSelect.init();
    FloatingMessage.init();
    ModalVideoWithParameters.init();
});
